import React, {useContext, useEffect} from 'react';
import './NRSLockPage.scss';
import LockTabsNavigation from "./LockTabs/LockTabsNavigation";
import LockButtons from "./LockButtons/LockButtons";
import {lockBalanceStore} from "../../../stores/LockBalanceStore";
import {depositWithdrawalLockStore} from "../../../services/deposit-withdrawal-lock/deposit-withdrawal-lock.store";
import {useAccount, useBlockNumber} from "wagmi";
import {ContractContext} from "../../../context-providers/ContractsProvider";
import {useBreakpointContext} from "../../../context-providers/BreakpointProvider";

const NRSLockPage = () => {
    const { xs, md } = useBreakpointContext();
    const { data: blockNumber } = useBlockNumber({ watch: true });
    const { address: userAddress } = useAccount();
    const { nrsContract, lockNrsContract, nrsLockWithdrawalTimelockContract } = useContext(ContractContext);

    useEffect(() => {
        if (!userAddress) {
            lockBalanceStore.resetState()
            depositWithdrawalLockStore.resetState()
        }
    }, [userAddress]);

    useEffect(() => {
        if (userAddress && blockNumber !== undefined) {
            lockBalanceStore.fetchBalancesThrottled(nrsContract, lockNrsContract, userAddress);
            depositWithdrawalLockStore.fetchWithdrawalsThrottled(nrsLockWithdrawalTimelockContract, userAddress)
        }
    }, [userAddress, nrsContract, lockNrsContract, nrsLockWithdrawalTimelockContract, blockNumber]);

    return (
        <div className="LockPage justify-start flex-col flex-grow">
            {md && (
                <div className="LockPage__header flex md">
                    <div className="balances card-container flex">
                        <div className="flex-col">
                            <label className="nereus-caption nereus-color-neutral-grey">Wallet&nbsp;Balance NRS</label>
                            <div className={`nereus-body-m`}>{lockBalanceStore.nrsTokenBalanceDecimal}</div>
                        </div>
                        <div className="flex-col">
                            <label className="nereus-caption nereus-color-neutral-grey">Locked&nbsp;NRS</label>
                            <div className={`nereus-body-m`}>{lockBalanceStore.nrsAvailableBalanceDecimal}</div>
                        </div>
                        <div className="buttons flex flex-grow align-item">
                            <LockButtons/>
                        </div>
                    </div>
                </div>
            )}
            {!md && !xs && (
                <div className="LockPage__header flex flex-col">
                    <div className="balances card-container flex">
                        <div className="flex-col">
                            <label className="nereus-caption nereus-color-neutral-grey">Wallet&nbsp;Balance&nbsp;NRS</label>
                            <div className={`nereus-body-m`}>{lockBalanceStore.nrsTokenBalanceDecimal}</div>
                        </div>
                        <div className="flex-col">
                            <label className="nereus-caption nereus-color-neutral-grey">Locked&nbsp;NRS</label>
                            <div className={`nereus-body-m`}>{lockBalanceStore.nrsAvailableBalanceDecimal}</div>
                        </div>
                        <div className="buttons flex flex-grow">
                            <LockButtons/>
                        </div>
                    </div>
                </div>
            )}
            {xs && (
                <div className="LockPage__header flex flex-col">
                    <div className="balances card-container flex-col">
                        <div className="flex">
                            <div className="flex-col">
                                <label className="nereus-caption nereus-color-neutral-grey">Wallet Balance NRS</label>
                                <div className={`nereus-body-m`}>{lockBalanceStore.nrsTokenBalanceDecimal}</div>
                            </div>
                            <div className="flex-col">
                                <label className="nereus-caption nereus-color-neutral-grey">Locked NRS</label>
                                <div className={`nereus-body-m`}>{lockBalanceStore.nrsAvailableBalanceDecimal}</div>
                            </div>
                        </div>
                        <div className="buttons flex flex-grow">
                            <LockButtons/>
                        </div>
                    </div>
                </div>
            )}
            <LockTabsNavigation/>
        </div>
    );
}

export default NRSLockPage;